import { render, staticRenderFns } from "./tabTradeDetail.vue?vue&type=template&id=581c26c6&"
import script from "./tabTradeDetail.vue?vue&type=script&lang=js&"
export * from "./tabTradeDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('581c26c6')) {
      api.createRecord('581c26c6', component.options)
    } else {
      api.reload('581c26c6', component.options)
    }
    module.hot.accept("./tabTradeDetail.vue?vue&type=template&id=581c26c6&", function () {
      api.rerender('581c26c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SeaExport/components/booking/tabs/tabTradeDetail.vue"
export default component.exports